import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=9ab0bbdc&lang=less&scoped=true"

import exportComponent from "D:\\webqpyx\\qpyx-korea-webs-hongkong-cosmo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ab0bbdc"]])

export default __exports__